/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The saga for send GTM analytics
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.1.0
 */

import { SagaIterator } from 'redux-saga';
import { all, select, takeEvery } from 'redux-saga/effects';

import { EAccountType } from '../../../pages/PageAuth/constants/authConstants';
import { makeSelectAuthAccountType, makeSelectorAuthSusrId, makeSelectUserTypeId } from '../../../pages/PageAuth/selectors/authSelectors';
import { PUSH_GTM_ANALYTIC } from './GTMconstants';
import { gtmOperationPush } from './GTMOperations';
import { TGTMPushAnalyticAction } from './types/GTMActionTypes';
import { mapAccountTypeToGTMAccountType } from './types/GTMMapTypes';

export function* pushGtmAnalyticSaga({ payload }: TGTMPushAnalyticAction): SagaIterator {
    const gtmOperations = payload.operation;

    if (payload.withAccountType) {
        const accountType: EAccountType = yield select(makeSelectAuthAccountType());
        //eslint-disable-next-line
        gtmOperations.b2bLK_account_type = mapAccountTypeToGTMAccountType[accountType];
    }

    if (payload.withSusrId) {
        //eslint-disable-next-line
        gtmOperations.susr_id = yield select(makeSelectorAuthSusrId());
    }

    if (payload.withUserRole) {
        //eslint-disable-next-line
        gtmOperations.user_role = yield select(makeSelectUserTypeId());
    }

    gtmOperationPush(gtmOperations);
}

export function* GTMSaga() {
    yield all([
        takeEvery(PUSH_GTM_ANALYTIC, pushGtmAnalyticSaga),
    ]);
}
